import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { readPublicError } from '@/api/error';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function NewMonitorPage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    const formData = new FormData(e.currentTarget);
    const frequency = Number(formData.get('frequency'));

    try {
      const response = await fetch('/api/monitors', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          name: formData.get('name'),
          url: formData.get('url'),
          rrule: `FREQ=MINUTELY;INTERVAL=${frequency}`,
          enabled: true,
        }),
      });

      if (response.ok) {
        navigate('/dashboard/monitors');
      } else {
        setError(await readPublicError(response, 'Failed to create monitor'));
      }
    } catch (error) {
      console.error('Failed to create monitor:', error);
      setError('Failed to create monitor');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-4 border-b">
            <h1 className="text-xl font-semibold text-gray-900">Add New Monitor</h1>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-6">
            {error ? (
              <div className="rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">
                {error}
              </div>
            ) : null}
            <div>
              <Label htmlFor="name">Monitor Name</Label>
              <Input id="name" name="name" placeholder="My Website" required className="mt-1" />
            </div>

            <div>
              <Label htmlFor="url">URL to Monitor</Label>
              <Input
                id="url"
                name="url"
                type="url"
                placeholder="https://example.com"
                required
                className="mt-1"
              />
            </div>

            <div>
              <Label htmlFor="frequency">Probe Frequency (minutes)</Label>
              <Input
                id="frequency"
                name="frequency"
                type="number"
                min="1"
                defaultValue="5"
                required
                className="mt-1"
              />
            </div>

            <div className="flex gap-3 pt-4 border-t">
              <Button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Creating...' : 'Create Monitor'}
              </Button>
              <Button
                type="button"
                variant="outline"
                onClick={() => navigate('/dashboard/monitors')}
              >
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
